import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { translate } from 'react-switch-lang';
import sitemap from '../Sitemap';

// STYLES
const NavContainer = styled.div`
  background-color: white;
  position: fixed;
  top: 140px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  text-align: center;
  overflow: scroll;

  @media only screen and (min-width: ${props => props.theme.flexboxgrid.breakpoints.md}em) {
    display: none;
  }
`;

const Nav = styled.nav`
  padding: 15px;
  margin: 0 auto;
  text-align: left;

  ul {
    list-style: none;
    display: block;
    padding: 0;
    margin: 0;
  }
`;

const MobileNavLink = styled(NavLink)`
  text-decoration: none;
  font-size: 1.8rem;
  text-transform: uppercase;

  &:hover {
    text-decoration: none;
  }

  &.active {
    font-weight: bold;
  }
`;

const NavItem = styled.li`
  color: ${props => props.theme.greyDark};
  border-bottom: 2px solid ${props => props.theme.greyDark};
  padding-bottom: 2px;
  margin-top: 8px;
`;

// COMPONENT
const  MobileNavigation = props => {

  let result = null;


  if (props.show) {
    result = (
      <NavContainer>
        <Nav>
          <ul>
            { sitemap.map(page => (
              <NavItem onClick={ props.toggle }>
                <MobileNavLink
                  to={ page.link }
                  key={ page.alias }
                >

                  { page.label }

                </MobileNavLink>
              </NavItem>
            )) }
          </ul>
        </Nav>
      </NavContainer>
    );
  }
  return (
    <div>{result}</div>
  );
};

export default translate(MobileNavigation);

